import "./Channel.scss";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Form, Image, Input, message } from "antd";
import AWS from "aws-sdk";

import Swal from "sweetalert2";

import inquiryApi from "../../apis/Inquiry.api";
import partnersApi from "../../apis/Partners.api";
import { toastAlert } from "../../components/AlertComponent";
import { setLoading } from "../../redux/store/common/commonDuck";

AWS.config.update({
	accessKeyId: process.env.REACT_APP_S3_ACCESSKEYID,
	secretAccessKey: process.env.REACT_APP_S3_SECRETACCESSKEY,
	region: process.env.REACT_APP_S3_REGION,
});

const s3 = new AWS.S3();

const InquiryBoardEditor = (props) => {
	const boardId = props.match.params?.id;
	const dispatch = useDispatch();
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const cUser = useSelector((state) => state.auth.channelUser);
	const inputRef = useRef(null);

	const [inquiryValue, setInquiryValue] = useState({
		title: null,
		content: null,
		is_secret: false,
	});

	const [biggestTitle, setBiggestTitle] = useState(0);

	useEffect(() => {
		if (!!reduxChannel?.user_id && !!cUser?.id && boardId !== "new") {
			getInquiryBoard();
		}
	}, [reduxChannel, cUser, boardId]);

	/**
	 * 상담게시글 단건 조회
	 * @returns {Promise<void>}
	 */
	const getInquiryBoard = async () => {
		const param = {
			inquiryId: boardId,
			influencerId: reduxChannel?.user_id,
			userId: cUser?.id ?? 0,
		};

		const res = await inquiryApi.readInquiryBoard(param);

		if (res.code === 200) {
			setInquiryValue(res.result?.inquiry);

			// 질문 이미지 리스트
			if (res.result?.inquiryImageList?.length > 0) {
				// 타이틀 중 가장 큰 값 저장
				let bigTitle =
					res.result?.inquiryImageList
						?.reduce((prev, value) => {
							return prev?.title?.split("-")?.[1] >=
								value?.title?.split("-")?.[1]
								? prev
								: value;
						})
						?.title?.split("-")?.[1] ?? 0;
				setBiggestTitle(bigTitle ? Number(bigTitle) : 0);

				let list = [];
				let photos = [];
				for (let i = 0; i < res.result?.inquiryImageList?.length; i++) {
					let resultImageList = res.result?.inquiryImageList[i];
					let source = `${process.env.REACT_APP_S3_HOST}/image/together/inquiry/board/${reduxChannel?.user_id}/${resultImageList?.title}.${resultImageList?.img_type}`;
					list.push(source);
					photos.push({
						title: resultImageList?.title,
						source: source,
						type: `image/${resultImageList?.img_type}`,
					});
				}
				// 최대 5개까지
				setImageList(list.slice(0, 5));
				setPhotoList(photos.slice(0, 5));
			} else {
				setImageList([]);
				setPhotoList([]);
			}
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("get-inquiry-each-error");
				setIsLoading(false);
			});
		}
	};

	const handleInquiryValue = (e) => {
		let { name, value } = e.target;
		setInquiryValue({
			...inquiryValue,
			[name]: value,
		});
	};

	const [imageList, setImageList] = useState([]);
	const [photoList, setPhotoList] = useState([]);

	/**
	 * 프론트 내 업로드 버튼 클릭
	 */
	const onUploadImageClick = () => {
		if (imageList?.length >= 5) {
			toastAlert("이미지는 최대 5장까지 가능합니다.");
		} else {
			if (!inputRef.current) {
				return;
			}
			inputRef.current.click();
		}
	};

	/**
	 * 프론트 내 업로드 진행
	 * @param e
	 */
	const onUploadImage = (e) => {
		if (!e.target.files) {
			return;
		}
		const fileList = e.target.files;
		const urlList = [...imageList];
		const photoInfoList = [...photoList];
		for (let i = 0; i < fileList?.length; i++) {
			const fileUrl = URL?.createObjectURL(fileList[i]);
			urlList.push(fileUrl);
			photoInfoList.push({
				file: fileList[i],
				source: fileUrl,
				type: fileList[i]?.type,
			});
		}
		setImageList(urlList?.slice(0, 5));
		setPhotoList(photoInfoList?.slice(0, 5));
	};

	/**
	 * 목록으로
	 */
	const goBackToInquiryList = () => {
		if (
			!!inquiryValue?.title?.replaceAll(" ", "")?.length ||
			!!inquiryValue?.content?.replaceAll(" ", "")?.length ||
			!!imageList?.length
		) {
			Swal.fire({
				customClass: "alert-custom",
				text: `작성하던 글이 있습니다. 취소하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					history.goBack();
				}
			});
		} else {
			// setCommunityWriteShow(false);
			history.goBack();
		}
	};

	/**
	 * 작성 완료
	 */
	const submitInquiryData = async () => {
		const type = boardId === "new" ? "save" : "edit";

		if (
			!inquiryValue?.title?.replaceAll(" ", "")?.length ||
			!inquiryValue?.content?.replaceAll(" ", "")?.length
		) {
			toastAlert("질문과 내용을 모두 작성해주세요.");
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: `작성을 완료하고 적용하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					setIsLoading(true);
					let param = {
						influencer_id: reduxChannel?.user_id,
						title: inquiryValue?.title,
						content: inquiryValue?.content,
						is_secret: inquiryValue?.is_secret,
						created_by: cUser?.id,
					};

					if (type === "edit") {
						param = {
							...param,
							id: boardId,
						};
					}

					const res = await inquiryApi.postInquiry(param);

					if (res.code === 200) {
						addInquiryImageList(res.result);
					} else {
						Swal.fire({
							customClass: "alert-custom",
							text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
							confirmButtonText: "확인",
						}).then(() => {
							console.log("post-inquiry-error");
							setIsLoading(false);
						});
					}
				}
			});
		}
	};

	/**
	 * 이미지 업로드
	 * @returns {Promise<void>}
	 * result: 결과값 -> id
	 * type: edit / save
	 */
	const addInquiryImageList = async (result) => {
		let list = [];
		for (let i = 0; i < photoList?.length; i++) {
			let photo = photoList[i];

			// 등록
			if (photo?.file) {
				uploadToS3(result, photo, i);
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			}
			// 수정
			else {
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: photo?.title ?? `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			}
		}

		const param = {
			id: result?.id,
			influencer_id: reduxChannel?.user_id,
			is_inquiry: true,
			created_by: cUser?.id,
			inquiryImageList: [...list],
			answerImageList: [],
		};

		const res = await inquiryApi.postInquiryImages(param);
		if (res.code === 200) {
			Swal.fire({
				customClass: "alert-custom",
				text: "성공적으로 적용되었습니다!",
				confirmButtonText: "확인",
			}).then(() => {
				history.replace(
					`/together/channel/inquiry/board?id=${reduxChannel?.influencer_id}`
				);
				setIsLoading(false);
			});
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("inquiry-image-list-error");
				setIsLoading(false);
			});
		}
	};

	/**
	 * 이미지 S3 업로드
	 * @param result
	 * @param photo
	 * @param i
	 * @returns {Promise<void>}
	 */
	const uploadToS3 = async (result, photo, i) => {
		let fileType = photo?.type?.split("/")[1];
		let s3Path = `image/together/inquiry/board/${reduxChannel?.user_id}/${
			result?.id
		}-${biggestTitle + i + 1}.${fileType}`;
		//aws-sdk 사용
		let params = {
			Bucket: process.env.REACT_APP_S3_BUCKETNAME,
			Key: s3Path,
			Body: photo.file,
		};

		let res = await s3.putObject(params).promise();

		if (res.$response.httpResponse.statusCode === 200) {
			console.log("inquiry-s3-upload-success");
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "이미지 업로드 오류",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("inquiry-s3-upload-error");
				setIsLoading(false);
			});
		}
	};

	/**
	 * 이미지 삭제 (목록에서 제거 -> 작성/수정완료 클릭 시 적용)
	 * @param idx
	 */
	const onDeleteImage = (idx) => {
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 이미지를 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				let list = [...imageList];
				let photos = [...photoList];
				list.splice(idx, 1);
				photos.splice(idx, 1);
				setImageList(list);
				setPhotoList(photos);
			}
		});
	};

	return (
		<div className="channel-home">
			<div className={`home-body`}>
				<div className={`max-width-apply`}>
					<div className={`inquiry-board-editor-title`}>
						<p>상담 글쓰기</p>
					</div>
					<Form className={`inquiry-board-editor-form`}>
						<Form.Item
							colon={false}
							className={`inquiry-board-editor-form-item`}
						>
							<Input
								type={`text`}
								disabled={isLoading}
								placeholder={`제목을 입력해 주세요.`}
								value={inquiryValue?.title}
								onChange={handleInquiryValue}
								name={`title`}
							/>
						</Form.Item>
						<Form.Item
							// label={`카테고리명`}
							// labelAlign="left"
							colon={false}
							className={`inquiry-board-editor-form-item`}
							required={true}
						>
							<Input.TextArea
								type={`text`}
								disabled={isLoading}
								placeholder={`내용을 입력해 주세요.`}
								value={inquiryValue?.content}
								onChange={handleInquiryValue}
								name={`content`}
							/>
						</Form.Item>
						<div className={`inquiry-board-editor-image-group`}>
							<button
								className={`inquiry-board-editor-image-button`}
								style={{ padding: 0 }}
								onClick={onUploadImageClick}
								disabled={isLoading}
							>
								<input
									type="file"
									multiple="multiple"
									accept="image/*"
									style={{
										display: "none",
									}}
									ref={inputRef}
									onChange={onUploadImage}
								/>
								<img
									src={`/assets/images/channel/img-add.png`}
									onError={({ currentTarget }) => {
										currentTarget.onerror = null; // prevents looping
										// currentTarget.style.display = "none";
										currentTarget.src = `/assets/images/channel/img-add.png`;
									}}
									alt={`상품 이미지`}
								/>
							</button>
							<Image.PreviewGroup>
								<div className={`image-preview-group`}>
									{imageList?.map((src, idx) => (
										<div
											className={`image-div`}
											key={`image-community-images-key-${idx}`}
										>
											<Image
												preview={{
													mask: <></>,
												}}
												src={src}
												alt={`상담 글 이미지 ${idx}`}
											/>
											<img
												src={`/assets/images/channel/cancel.png`}
												alt={`이미지 삭제`}
												className={`image-delete-icon`}
												onClick={() => onDeleteImage(idx)}
											/>
										</div>
									))}
								</div>
							</Image.PreviewGroup>
						</div>
						<p>* 이미지는 최대 5장까지 가능합니다.</p>

						<div className={`inquiry-board-editor-footer`}>
							<button
								className={`inquiry-board-editor-secret-button`}
								onClick={() => {
									setInquiryValue({
										...inquiryValue,
										is_secret: !inquiryValue.is_secret,
									});
								}}
								disabled={isLoading}
							>
								<img
									src={`/assets/images/login/check${
										inquiryValue?.is_secret ? "-active" : ""
									}.png`}
									alt={`비밀글`}
									style={{
										height: "100%",
										width: "1.2em",
									}}
								/>
								{/*비밀글로 작성하기*/}
								비밀글
							</button>
							<div className={`inquiry-board-editor-button-group`}>
								<Button onClick={goBackToInquiryList} loading={isLoading}>
									돌아가기
								</Button>
								<Button
									className={`black`}
									onClick={submitInquiryData}
									loading={isLoading}
								>
									{boardId === "new" ? "작성완료" : "수정완료"}
								</Button>
							</div>
						</div>
					</Form>
				</div>
			</div>
		</div>
	);
};
export default InquiryBoardEditor;
